module.exports = __webpack_public_path__ + "images/stickers/huh.405fd9e6997ac365e4da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/huh.png
// module id = nho9
// module chunks = 1